import { Badge } from "@/components/ui/badge"
import {
  AlertCircle,
  Archive,
  CheckCircle,
  Clock,
  FileText,
  Loader2,
  Radio,
  Sparkles,
  Users,
} from "lucide-react"

// One map for every Meeting status, shared by the coach and admin meeting
// tables. A status added to Meeting.status lands here once, not in each page.
export const meetingStatusConfig = {
  pending: {
    label: "Pending",
    className: "bg-zinc-100 text-zinc-700 border-zinc-200",
    icon: Clock,
  },
  bot_joining: {
    label: "Bot Joining",
    className: "bg-amber-50 text-amber-700 border-amber-200 animate-pulse",
    icon: Loader2,
  },
  recording: {
    label: "Recording",
    className: "bg-red-50 text-red-700 border-red-200",
    icon: Radio,
  },
  processing_transcript: {
    label: "Processing",
    className: "bg-blue-50 text-blue-700 border-blue-200",
    icon: FileText,
  },
  awaiting_claim: {
    label: "Awaiting Claim",
    className: "bg-amber-50 text-amber-700 border-amber-200",
    icon: Users,
  },
  generating_article: {
    label: "Generating",
    className: "bg-purple-50 text-purple-700 border-purple-200",
    icon: Sparkles,
  },
  completed: {
    label: "Completed",
    className: "bg-green-50 text-green-700 border-green-200",
    icon: CheckCircle,
  },
  failed: {
    label: "Failed",
    className: "bg-red-50 text-red-700 border-red-200",
    icon: AlertCircle,
  },
  skipped: {
    label: "Not Interview",
    className: "bg-zinc-100 text-zinc-500 border-zinc-200",
    icon: FileText,
  },
  archived: {
    label: "Archived",
    className: "bg-zinc-100 text-zinc-500 border-zinc-200",
    icon: Archive,
  },
}

export function MeetingStatusBadge({ status }) {
  const config = meetingStatusConfig[status] || meetingStatusConfig.pending
  const Icon = config.icon
  return (
    <Badge variant="outline" className={config.className}>
      <Icon className={`h-3 w-3 ${status === "recording" ? "animate-pulse" : ""}`} />
      {config.label}
    </Badge>
  )
}
